import {useState, useEffect} from "react";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import CkEditorHelper from "../CkEditorHelper";
import Constants from "../Constants";
import {useNavigate} from "react-router-dom";

const CreatePostPage = ({mainUser, categoryIdSetter}) => {

    const [postTitle, setPostTitle] = useState("");
    const [postBody, setPostBody] = useState("");
    const [postKeyWord, setPostKeyWord] = useState("");
    const [postCoverImageFile, setPostCoverImageFile] = useState({});
    const [postSummery, setPostSummery] = useState("");
    const [postCategoryId, setPostCategoryId] = useState("");
    const [postSubCategoryId, setPostSubCategoryId] = useState("");

    const [selectionOptions, setSelectionOptions] = useState([]);
    const [selectSubCats, setSelectSubCats] = useState([]);
    const navigator = useNavigate();

    /*  useEffect(() => {
          if (mainUser.userMode !== "admin") {
              navigator("/");
          }
      }, [mainUser]);*/

    const afterPostCreated = () => {
        categoryIdSetter([postCategoryId, postSubCategoryId]);
        navigator("/posts_list");
    }

    useEffect(() => {
        const fetchCategories = async () => {
            const catRes = await getCategories();
            setSelectionOptions(catRes.categories);
            setPostCategoryId(catRes.categories[0].id);
        }


        fetchCategories();
        document.getElementById("post_category").onfocus = true;
    }, []);

    useEffect(() => {
        const fetchSubCats = async () => {
            const subCatRes = await getSubCategories();
            setSelectSubCats(subCatRes.sub_categories);
            setPostSubCategoryId(subCatRes.sub_categories[0].id);
        }
        fetchSubCats();

    }, []);

    const formData = new FormData();
    const MyCustomUploadAdapterPlugin = (editor) => {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            // Configure the URL to the upload script in your back-end here!
            return new CkEditorHelper(loader);
        };
    }

    const getCategories = async () => {
        let url = Constants.BaseUrl.concat("categories");
        const categoryRes = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        });
        return await categoryRes.json();
    }

    const getSubCategories = async () => {
        let url = Constants.BaseUrl.concat("blog_sub_category");
        const subCatRes = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        });
        return await subCatRes.json();
    }

    const config =
        {
            // extraPlugins: [MyCustomUploadAdapterPlugin],
            toolbar: {
                items: [
                    'heading',
                    '|',
                    'fontSize',
                    'fontFamily',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'imageInsert',
                    // 'imageUpload',
                    'blockQuote',
                    'insertTable',
                    // 'mediaEmbed',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'link',
                    '|',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'outdent',
                    'indent',
                    'alignment',
                    'pageBreak',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    // 'restrictedEditingException',
                    // 'code',
                    'codeBlock',
                    'findAndReplace',
                    'htmlEmbed',
                    '|',
                    'specialCharacters',
                    'subscript',
                    'superscript',
                    'highlight',
                ],
                shouldNotGroupWhenFull: true
            },
            language: 'fa',
            image: {
                toolbar: [
                    'imageTextAlternative',
                    'imageStyle:inline',
                    'imageStyle:block',
                    'imageStyle:side',
                    'linkImage'
                ]
            },
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells',
                    'tableCellProperties',
                    'tableProperties'
                ]
            },
            fontFamily: {
                options: [
                    'default',
                    'Ubuntu, Arial, sans-serif',
                    'Ubuntu Mono, Courier New, Courier, monospace',
                    'B Nazanin',
                    'B Bardiya',
                    'B Elham',
                    'B Elm',
                    'B Esfehan',
                    'B Hamid',
                    'B Helal',
                    'B Zar',
                    'B Tehran',
                    'B Yekta',
                    'B Mitra',
                    'B Shiraz',
                    'B Yagut',
                    'B Ferdosi',
                    'B Baran',
                    'B Aseman',
                    'B Titr',
                    'B Davat',
                    'A BANOO THIN',
                ],
                supportAllValues: true
            },
            licenseKey: ''

        }

    const onImageInserted = (e) => {
        e.preventDefault();
        setPostCoverImageFile(e.target.files[0]);
        // console.log(e.target.files[0]);
    }


    const uploadPost = async () => {
        formData.append('post_title', postTitle);
        formData.append('post_body', postBody);
        formData.append('post_key_words', postKeyWord);
        formData.append('post_summery', postSummery);
        formData.append('post_cover_image', postCoverImageFile);
        formData.append('post_category_id', postCategoryId);
        formData.append('sub_cat_id', postSubCategoryId);
        let url = Constants.BaseUrl.concat("create_new_blog_post");
        const res = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                /*'Content-Type': 'multipart/form-data',
                'Accept':'application/json',*/
                // 'Authorization': 'Bearer '.concat(sessionStorage.getItem("user") != null && JSON.parse(sessionStorage.getItem("user")).token),
                'Authorization': 'Bearer '.concat(mainUser.token),
            },
            body: formData,
        }).catch((reason) => (console.log(reason)));
        // console.log(await res.json());
        return JSON.stringify(await res.json());

    }

    const submitForm = async (e) => {
        e.preventDefault();
        const res = await uploadPost();
        let createAns = (JSON.parse(res));
        if (createAns.state === "success") {
            alert("پست با موفقیت ایجاد شد.")
            afterPostCreated();
        } else {
            alert("پست ایجاد نشد. در ذخیره سازی یا ارسال درخواست مشکلی پیش آمده است.");
        }

    }

    const cancelPost = (e) => {
        e.preventDefault();
        setPostCategoryId(selectionOptions[0].id);
        setPostTitle("");
        setPostCoverImageFile({});
        setPostBody("");
        setPostSummery("");
        setPostKeyWord("");
        document.getElementById("cover_image_add").value = "";
    }


    return (
        <>
            <div className="container mt-5 mx-auto p-2 text-center justify-content-center">

                <h2>ایجاد پست جدید</h2>

                <form onSubmit={submitForm}>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="post_category"
                                   className="col-form-label text-md-start text-center fw-bolder">دسته بندی پست</label>
                            <select id="post_category"
                                    className="form-control"
                                    name="post_category"
                                    value={postCategoryId}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setPostCategoryId(e.target.value)
                                    }}
                                    autoFocus={true}
                            >
                                {selectionOptions.map((item, index) => (
                                    <option key={item.id} value={item.id}>{item.title}</option>
                                ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="post_sub_category"
                                   className="col-form-label text-md-start text-center fw-bolder">زیر دسته بندی
                                پست</label>
                            <select id="post_sub_category"
                                    className="form-control"
                                    name="post_sub_category"
                                    value={postSubCategoryId}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setPostSubCategoryId(e.target.value);
                                    }}
                                    autoFocus={true}
                            >
                                {selectSubCats.map((item, index) => (
                                    <option key={item.id} value={item.id}>{item.sub_cat_title}</option>
                                ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="post_title"
                                   className="col-form-label text-md-start text-center fw-bolder">عنوان پست</label>
                            <input id="post_title" type="text"
                                   title="این قسمت را پر کنید."
                                   placeholder="عنوان پست"
                                   className="form-control"
                                   value={postTitle}
                                   name="post_title"
                                   required
                                   onChange={(e) => {
                                       e.preventDefault();
                                       setPostTitle(e.target.value);
                                       // console.log(e.target.value);
                                   }}
                                   maxLength="70"
                                   autoComplete="post_title"/>
                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="cover_image_add"
                                   className="col-form-label text-md-end text-center fw-bolder">عکس کاور پست</label>
                            <input id="cover_image_add" type="file"
                                   placeholder="عکس کاور پست"
                                   className="form-control"
                                   name="cover_image_add"
                                   onChange={onImageInserted}
                            />
                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="post_body"
                                   className="col-form-label text-md-end text-center fw-bolder">متن اصلی پست</label>
                            {/*//CKEditor*/}

                            <CKEditor
                                id="post_body"
                                editor={Editor}
                                data={postBody}
                                config={config}
                                pluginName={MyCustomUploadAdapterPlugin}
                                onReady={editor => {
                                    // You can store the "editor" and use when it is needed.
                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                                        // Configure the URL to the upload script in your back-end here!
                                        return new CkEditorHelper(loader);
                                    };
                                    // console.log('Editor is ready to use!', editor);
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    // console.log({event, editor, data});
                                    setPostBody(data);
                                }}
                                onBlur={(event, editor) => {
                                    // console.log('Blur.', editor);
                                }}
                                onFocus={(event, editor) => {
                                    // console.log('Focus.', editor);
                                }}
                            />

                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="body_summery"
                                   className="col-form-label text-md-end text-center fw-bolder">خلاصه ای از متن
                                پست</label>
                            <textarea id="body_summery" type="text"
                                      title="این قسمت را پر کنید."
                                      cols="15"
                                      rows="6"
                                      value={postSummery}
                                      placeholder="خلاصه ای از متن"
                                      className="form-control"
                                      name="body_summery"
                                      maxLength="700"
                                      onChange={(e) => {
                                          e.preventDefault();
                                          setPostSummery(e.target.value);
                                          // console.log(e.target.value);
                                      }}
                                      autoComplete="body_summery"
                            />
                        </div>
                    </div>
                    <div className="form-group row justify-content-center my-2">
                        <div className="col-md-10 text-md-end text-center">
                            <label htmlFor="key_words"
                                   className="col-form-label text-md-end text-center fw-bolder">کلمات کلیدی</label>
                            <input id="key_words" type="text"
                                   title="این قسمت را پر کنید."
                                   placeholder="کلمات کلیدی را با '|' از هم جدا کنید."
                                   className="form-control"
                                   value={postKeyWord}
                                   name="key_words"
                                   maxLength="300"
                                   onChange={(e) => {
                                       e.preventDefault();
                                       setPostKeyWord(e.target.value);
                                       // console.log(e.target.value);
                                   }}
                                   autoComplete="key_words"/>
                        </div>
                    </div>


                    <div className="form-group row mb-3 mt-3 justify-content-center text-center">
                        <div className="col-md-12">
                            <button type="submit" className="btn btn-primary btn-lg m-2 text-light">
                                ایجاد پست
                            </button>
                            <button onClick={cancelPost} className="btn btn-secondary btn-lg text-light m-2">
                                انصراف
                            </button>
                        </div>
                    </div>
                </form>


            </div>

        </>
    )
}

export default CreatePostPage;